/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_AllocationInputs */

const en_admin_allocation_form_allocation = /** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation`)
};

const de_admin_allocation_form_allocation = /** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisung`)
};

const es_admin_allocation_form_allocation = /** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignación`)
};

const fr_admin_allocation_form_allocation = /** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribution`)
};

const nl_admin_allocation_form_allocation = /** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toewijzing`)
};

/** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */
const it_admin_allocation_form_allocation = en_admin_allocation_form_allocation;

/** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_allocation = en_admin_allocation_form_allocation;

/** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */
const pl_admin_allocation_form_allocation = en_admin_allocation_form_allocation;

/** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */
const hu_admin_allocation_form_allocation = en_admin_allocation_form_allocation;

/** @type {(inputs: Admin_Allocation_Form_AllocationInputs) => LocalizedString} */
const ro_admin_allocation_form_allocation = en_admin_allocation_form_allocation;

/**
* | output |
* | --- |
* | "Allocation" |
*
* @param {Admin_Allocation_Form_AllocationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_allocation = /** @type {((inputs?: Admin_Allocation_Form_AllocationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_AllocationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_allocation(inputs)
	if (locale === "de") return de_admin_allocation_form_allocation(inputs)
	if (locale === "es") return es_admin_allocation_form_allocation(inputs)
	if (locale === "fr") return fr_admin_allocation_form_allocation(inputs)
	if (locale === "nl") return nl_admin_allocation_form_allocation(inputs)
	if (locale === "it") return it_admin_allocation_form_allocation(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_allocation(inputs)
	if (locale === "pl") return pl_admin_allocation_form_allocation(inputs)
	if (locale === "hu") return hu_admin_allocation_form_allocation(inputs)
	return ro_admin_allocation_form_allocation(inputs)
});
export { admin_allocation_form_allocation as "admin.allocation_form.allocation" }